import { useContext, useEffect, useState } from "react";
import {
  TouchableOpacity,
  ImageBackground,
  StyleSheet,
  View,
  Text,
  Button,
  Platform,
} from "react-native";
import { FlatList } from "react-native-gesture-handler";
import Card from "../styles/Card";
import { globalStyles } from "../styles/globalStyles";
import RequestBook from "./RequestBook";
import { UserContext } from "../globalData/UserContext";
import { BooksContext } from "../globalData/BooksContext";
import { MaterialIcons } from "@expo/vector-icons";
import SendRequest from "./SendRequest";
import FilterRecommendations from "./components/FilterRecommendations";
import { getBooks } from "../src/graphql/queries";
import Blank from "./components/Blank";

// NOTE: code is repetitive --> same flatlist/retrieval book is used in multiple areas
export default function AvailableBooks({ navigation }) {
  const [itemClicked, setItemClicked] = useState({});
  const [books, setBooks] = useState([]);
  const [filteredBooks, setFilteredBooks] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const userData = useContext(UserContext);
  const booksData = useContext(BooksContext);
  const [empty, setEmpty] = useState(false);

  // instructions state: (NEED A BETTER METHOD OF DOING THIS)
  const [instructions, setInstructions] = useState(false);
  const [shareInst, setShareInst] = useState(false);
  const [borrowedInst, setBorrowedInst] = useState(false);
  const [mineInst, setMineInst] = useState(false);
  const [drawerInst, setDrawerInst] = useState(false);
  const [backInst, setBackInst] = useState(false);
  const [bookInst, setBookInst] = useState(false);

  useEffect(() => {
    if (booksData.books != null) getCommunityBooks();
    else booksData.refreshBooks();
  }, [booksData.books]);

  //vikas: every time user come to My books screen, will the query fire fresh
  // to the db or see any new books added or some books taken taken off?
  function getCommunityBooks() {
    const booksFiltered = booksData.books.filter(
      (book) =>
        book.status != "borrowed" &&
        book.usersOwnBooksUId != userData.user.data.getUsers.uId
    );
    setBooks(booksFiltered);
    setFilteredBooks(booksFiltered);
    if (booksFiltered.length == 0) setEmpty(true);
  }

  let numColumns;
  if (Platform.OS == "web") numColumns = 3;
  else numColumns = 1;
  return (
    <ImageBackground
      style={globalStyles.container}
      resizeMode="cover"
      source={
        !empty
          ? require("../assets/background.png")
          : require("../assets/blankBackground.png")
      }
    >
      <View style={{ flexDirection: "row" }}>
        <MaterialIcons
          name="info"
          color="#56494c"
          size={33}
          style={{}}
          onPress={() => {
            setInstructions(true);
          }}
        />
        <FilterRecommendations
          books={books}
          setFilteredBooks={setFilteredBooks}
          filteredBooks={filteredBooks}
        />
        {drawerInst && (
          <View style={{ ...globalStyles.instructions, width: "70%" }}>
            <Text style={{ ...globalStyles.paragraph }}>
              Use the drawer navigation in the top left to view the community
              and profile info.
            </Text>
            <Button
              title="next"
              onPress={() => {
                setBackInst(true);
                setDrawerInst(false);
              }}
            />
          </View>
        )}
        {instructions && (
          <View style={globalStyles.instructions}>
            <Text style={{ ...globalStyles.paragraph }}>
              This page shows all of the available books shared by community
              members. This does not include the books you have shared.
            </Text>
            <Button
              title="next"
              onPress={() => {
                setInstructions(false);
                setBookInst(true);
              }}
            />
          </View>
        )}
        {bookInst && (
          <View style={globalStyles.instructions}>
            <Text style={{ ...globalStyles.paragraph }}>
              Click on any of the books listed below to view more information
              about them and send a request to borrow them.
            </Text>
            <Button
              title="next"
              onPress={() => {
                setShareInst(true);
                setBookInst(false);
              }}
            />
          </View>
        )}
        {backInst && (
          <View style={{ ...globalStyles.instructions, width: "70%" }}>
            <Text style={{ ...globalStyles.paragraph }}>
              If you would like to navigate back to the communities page, click
              the back button in the left corner.
            </Text>
            <Button
              title="ok"
              onPress={() => {
                setBackInst(false);
              }}
            />
          </View>
        )}
      </View>
      <RequestBook
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        item={itemClicked}
        navigateToMyBooks={() => {
          navigation.navigate("My Books");
        }}
        refresh={() => {
          booksData.refreshBooks();
        }}
      />

      {empty && (
        <Blank
          titleText="Currently no books are added to this community."
          subtitleText="Head over to Share Books to start uncaging your books!"
          image={0}
        />
      )}
      <FlatList
        numColumns={numColumns}
        data={filteredBooks}
        style={{ flex: 1 }}
        renderItem={({ item }) => (
          <TouchableOpacity
            onPress={() => {
              setModalOpen(true);
              setItemClicked(item);
            }}
            style={{ flex: 1 }}
          >
            <Card
              uri={item.Image}
              title={item.title}
              status={item.status}
              user={item.usersOwnBooksUId}
              owner={true}
              authors={item.Author}
            />
          </TouchableOpacity>
        )}
      />
      {shareInst && (
        <View
          style={{
            ...globalStyles.instructions,
            width: "70%",
            height: "40%",
            flex: 0,
          }}
        >
          <Text style={{ ...globalStyles.paragraph, padding: 5 }}>
            Click the share tab below to add a book you own to the community
            (either manually or by searching for it). Once added, it will be
            visible for other members to borrow. You can view it in the my books
            tab.
          </Text>
          <Button
            title="next"
            onPress={() => {
              setShareInst(false);
              setBorrowedInst(true);
            }}
          />
        </View>
      )}
      {borrowedInst && (
        <View
          style={{
            ...globalStyles.instructions,
            width: "70%",
            height: "35%",
            flex: 0,
            marginLeft: 100,
          }}
        >
          <Text style={{ ...globalStyles.paragraph }}>
            Click the borrowed tab below to see the books you have borrowed from
            different community members. It will also display the borrow and due
            date.
          </Text>
          <Button
            title="next"
            onPress={() => {
              setMineInst(true);
              setBorrowedInst(false);
            }}
          />
        </View>
      )}
      {mineInst && (
        <View
          style={{
            ...globalStyles.instructions,
            width: "70%",
            height: "27%",
            flex: 0,
            marginLeft: 130,
          }}
        >
          <Text style={{ ...globalStyles.paragraph }}>
            Click the my books tab below to see all the books you have shared
            within the community. You may also remove your books here.
          </Text>
          <Button
            title="next"
            onPress={() => {
              setMineInst(false);
              setDrawerInst(true);
            }}
          />
        </View>
      )}
    </ImageBackground>
  );
}

const styles = StyleSheet.create({
  button: {
    flexDirection: "column",
    flex: 1,
    paddingLeft: 10,
    paddingTop: 60,
  },
});
